import * as React from 'react'
import { MarketingLayout } from '../components/marketing-layout'
import { MarketingPageContainer, PageTitle, PageSubtitle } from '../styles/marketing.styles'

export const BlogPage: React.FC = () => (
  <MarketingLayout>
    <MarketingPageContainer>
      <PageTitle>Blog</PageTitle>
      <PageSubtitle>Coming soon. We will share product updates and insights here.</PageSubtitle>
    </MarketingPageContainer>
  </MarketingLayout>
)
